import { createContext, useState } from "react";


export const MessageContext = createContext<MessageContextType | null>(null);

export type MessageContextType = {
  message: string;
  handleCloseMessageBar: () => void;
  handleShowMessageBar: (text: string, pauseOff: boolean) => void;
  showMessageBar: boolean;
  isPauseOff: boolean;
};

const MessageContainer = ({ children }) => {
  const [showMessageBar, setShowMessageBar] = useState(false);
  const [message, setMessage] = useState("");

  const [isPauseOff, setIsPauseOff] = useState(false);

  const handleShowMessageBar = (text: string, pauseOff: boolean) => {
    setMessage(text);
    setShowMessageBar(true);
    setIsPauseOff(pauseOff);
  };

  const handleCloseMessageBar = () => {
    setShowMessageBar(false);
  };

  return (
    <MessageContext.Provider
      value={{ message, handleCloseMessageBar, handleShowMessageBar, showMessageBar, isPauseOff }}
    >
      {children}
    </MessageContext.Provider>
  );
};

export default MessageContainer;
